import { render } from "./CompaniesTable.vue?vue&type=template&id=4accc76a"
import script from "./CompaniesTable.vue?vue&type=script&lang=js"
export * from "./CompaniesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__